/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListIdentityAccessSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type ListIdentityAccessRequest = {
  /**
   * The Speakeasy user ID to look up accessible resources for.
   */
  userId: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListIdentityAccessSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListIdentityAccessSecurity$outboundSchema: z.ZodMiniType<
  ListIdentityAccessSecurity$Outbound,
  ListIdentityAccessSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listIdentityAccessSecurityToJSON(
  listIdentityAccessSecurity: ListIdentityAccessSecurity,
): string {
  return JSON.stringify(
    ListIdentityAccessSecurity$outboundSchema.parse(listIdentityAccessSecurity),
  );
}

/** @internal */
export type ListIdentityAccessRequest$Outbound = {
  user_id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListIdentityAccessRequest$outboundSchema: z.ZodMiniType<
  ListIdentityAccessRequest$Outbound,
  ListIdentityAccessRequest
> = z.pipe(
  z.object({
    userId: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      userId: "user_id",
      gramSession: "Gram-Session",
    });
  }),
);

export function listIdentityAccessRequestToJSON(
  listIdentityAccessRequest: ListIdentityAccessRequest,
): string {
  return JSON.stringify(
    ListIdentityAccessRequest$outboundSchema.parse(listIdentityAccessRequest),
  );
}
